import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as STATES from 'src/assets/states.json';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';
import * as accents from 'remove-accents';
import * as moment from 'moment';
import { ViaCepService } from 'src/services/via-cep.service';
import { debounceTime } from 'rxjs/operators';
import { PlatformLocation } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  states: Array<any> = (STATES as any).default;
  form: FormGroup;
  formEditable: boolean = false;
  filteredStates$: Observable<any>;
  mauticFormSrc: any = null;

  constructor(
    private http: HttpService,
    fb: FormBuilder,
    private snackbar: MatSnackBar,
    private errorReport: ErrorReportService,
    private viaCep: ViaCepService,
    private pLocation: PlatformLocation,
    private sanitazer: DomSanitizer,
  ) {
    this.form = fb.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      email: [null, [Validators.required, Validators.required]],
      cpf: [null, [Validators.required, CustomValidators.cpf]],
      phone: [null, [Validators.required, CustomValidators.phone]],
      mobile: [null, [Validators.required, CustomValidators.phone]],
      gender: [null, Validators.required],
      birthday: [null, Validators.required],
      zipCode: [null, Validators.required],
      state: [null, Validators.required],
      city: [null, Validators.required],
      district: [null, Validators.required],
      street: [null, Validators.required],
      number: [null, Validators.required],
      aboutme: [null, Validators.required],
      complement: [null]
    });
  }

  ngOnInit(): void {

    const token = JSON.parse(localStorage.getItem('token'));

    this.http.get('profile', { id: token.id }).
      subscribe(
        (result: any) => {

          const { type, data } = result;
          // console.log('result', result);
          
          if (type === 'OK') {

            let state = data.state;
            let city = data.city;

            if (data.city !== null) {
              state = data.city.split(',')[2];
              city = data.city.split(',')[0];
            }

            for (const key in data) {
              const value = data[key];
              if (value === 'null' || value === 'undefined')
                data[key] = null;
            }

            this.form.patchValue({
              firstname: data.firstname,
              lastname: data.lastname,
              cpf: data.cpf,
              phone: data.phone,
              mobile: data.mobile,
              gender: data.gender,
              birthday: moment(data.birthdate).format('DD/MM/YYYY'),
              zipCode: data.zipcode,
              state: state,
              city: city,
              district: data.district,
              street: data.address1,
              number: data.address2,
              complement: data.complement,
              aboutme: data.aboutme,
              email: token.email
            });

          }

        }
      );

    this.filteredStates$ = this.form.get('state')
      .valueChanges
      .pipe(
        map(state => this._filterStates(state))
      );

    this.form.get('zipCode')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cep => {

          if (!this.form.get('zipCode').invalid) {
            this.viaCep.getLocation(cep)
              .subscribe(
                data => {
                  const { bairro, localidade, logradouro, uf } = data;
                  this.form.patchValue({
                    district: bairro,
                    city: localidade,
                    street: logradouro,
                    state: uf
                  });
                }
              )
          }
        }
      )

  }

  private _filterStates(state) {

    if (!state) return;

    let name = accents.remove(state.toLowerCase());
    return this.states.filter(_state => accents.remove(_state.nome).toLowerCase().indexOf(name) > -1
      || _state.sigla.toLowerCase().indexOf(name) > -1);

  }

  public editable(edit: boolean = true) {

    this.formEditable = edit;
    if (!edit)
      this.form.markAsPristine();

  }

  submit() {

    const isValid = !this.form.invalid;
    const data = this.form.getRawValue();

    const state = this.states.find(state => state
      ? state.nome.toLowerCase() ===
      data.state.toLowerCase() : null);

    data.city = data.city + ', ' + data.state;

    if (isValid) {

      data.birthday = moment(data.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD');

      this.http.save('profile', data)
        .subscribe(
          (result: any) => {

            if (result.type === 'OK') {
              this.snackbar.open('Atualização salva com sucesso!', 'OK', { duration: 3000 });
              //this.form.markAsPristine();
              this.editable(false);
            } else
              this.snackbar.open('Desculpe não foi possivel salvar alteração, tente novamente!', 'OK', { duration: 3000 });

          },
          err => this.errorReport.showMessage(err)
        )

        const params = new URLSearchParams();
  
        for (let key in data) {
          const value = data[key];
          if (value)
            params.append(key, value);
        }

        params.append('passo', '1');

        const hBase = this.pLocation.getBaseHrefFromDOM();
  
        this.mauticFormSrc = this.sanitazer
          .bypassSecurityTrustResourceUrl(`${hBase}mautic-form/progress?${params.toString()}`);

    }

  }

  excluir_conta() {
    if (!confirm('Deseja realmente excluir sua conta e todos os dados relacionado a ela? Essa ação não poderá ser desfeita'))
      return false;

    const data = this.form.getRawValue();
    const user = JSON.parse(localStorage.getItem('token'));

    data.id = user.id,

      this.http.save('profile:remove', data)
        .subscribe(
          (result: any) => {

            if (result.type === 'OK') {

              this.snackbar.open('Conta removida com sucesso!', 'OK', { duration: 3000 });
              localStorage.removeItem('token');
              localStorage.clear();
              setTimeout(() => window.location.reload(), 4000);

            } else
              this.snackbar.open('Desculpe não foi possível excluir a conta, por favor tente novamente!', 'OK', { duration: 3000 });
          },
          err => this.errorReport.showMessage(err)
        )
  }

}